import { useState, useEffect } from "react";
import useApi from "./useApi";

const useSupervisors = () => {
  const [supervisors, setSupervisors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { postData } = useApi();

  useEffect(() => {
    const fetchSupervisors = async () => {
      try {
        const result = await postData({
          entityName: "User",
          action: "getAllSupervisors",
        });

        if (result?.isSuccessful) {
          setSupervisors(result.data || []);
        }
      } catch (error) {
        console.error("Error fetching supervisors:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSupervisors();
  }, []); // Run once on mount

  return { supervisors, isLoading };
};

export default useSupervisors;
